import { FC } from 'react';
import { Container } from '@chakra-ui/react';

import { PageTopBar } from '../../components/page-top-bar/page-top-bar';

export const FileDetailsLayout: FC = ({ children }) => {
  return (
    <>
      <PageTopBar />
      <Container
        display="flex"
        flex={1}
        flexDirection="column"
        p={8}
        maxW="100%"
      >
        {children}
      </Container>
    </>
  );
};
